import { fetch } from "src/services/apollo-fetch";
import { Query } from "../_api";

export default {
    async fetchCustomer({ commit }, data) {
        const response = await fetch.query({
            query: Query.customer,
            variables: { id: data.id },
        });
        commit("setSelectedCustomer", response.data.customer);
    },
    clearSelectedCustomer({ commit }) {
        commit("setSelectedCustomer", {});
    },
    setReceiptLogsPerPage({ commit }, data) {
        commit("setReceiptLogsPerPage", data);
    },
};
